import { createSlice } from "@reduxjs/toolkit";
// utils
import axios from "../../utils/axios";
//
import { dispatch } from "../store";

// ----------------------------------------------------------------------

const initialState = {
  isLoading: false,
  error: null,
  annonces: [],
  best_scores: [],
};

const slice = createSlice({
  name: "annonce",
  initialState,
  reducers: {
    // START LOADING
    startLoading(state) {
      state.isLoading = true;
    },

    // HAS ERROR
    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },

    // GET ANNONCES
    getAnoncesSuccess(state, action) {
      state.isLoading = false;
      state.annonces = action.payload;
    },

    // GET BEST SCORED
    getBestScoredsSuccess(state, action) {
      state.isLoading = false;
      state.best_scores = action.payload;
    },
  },
});

// Reducer
export default slice.reducer;

// ----------------------------------------------------------------------

export function getAnnonces() {
  return async () => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get("/api/accounts/annonces");
      dispatch(slice.actions.getAnoncesSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getBestScoreds() {
  return async () => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get("/api/accounts/best-scores");
      dispatch(slice.actions.getBestScoredsSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}
